export default {
  USER_DATE_FORMAT: 'MM/dd/yyyy',
  ISO_DATE_FORMAT: 'yyyy-MM-dd',
  API_URL: process.env.REACT_APP_API_URL,
  API_WS_ROOT: process.env.API_WS_ROOT,
  API_TOKEN: process.env.REACT_APP_MERCHANT_TOKEN
}
